var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { AppColor } from '../const/AppDefaults';
import { testIsMobile } from '@@/Util';
import { StoreContext } from "../uistore/PwaRootStore";
import { GrDocumentMissing } from '@react-icons/all-files/gr/GrDocumentMissing';
import { PwaPdfViewer } from './PwaPDFViewer';
let PwaFloatingViewContainer = class PwaFloatingViewContainer extends React.Component {
    constructor() {
        super(...arguments);
        this.boxref = null;
        this.adjustx = 0;
        this.adjusty = 0;
        this.upcb = () => {
            const rstore = this.context;
            rstore.getPwaStore().setDragging(false);
        };
        this.mousemove = (e) => {
            const rstore = this.context;
            if (rstore.getPwaStore().dragging) {
                // lets move this dialog 
                rstore.getPwaStore().setTop(e.clientY - this.adjusty);
                rstore.getPwaStore().setLeft(e.clientX - this.adjustx);
            }
        };
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.upcb);
        window.addEventListener("mousemove", this.mousemove);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.upcb);
        window.removeEventListener("mousemove", this.mousemove);
    }
    render() {
        const rstore = this.context;
        if (!rstore.getPwaStore().show) {
            return React.createElement(React.Fragment, null);
        }
        if (testIsMobile()) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { "object-viewer": 'colorbox', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '4px', className: 'floating-dialog', zIndex: 5000, cursor: rstore.getPwaStore().dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("object-viewer")) {
                    rstore.getPwaStore().setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: rstore.getPwaStore().left + "px", top: rstore.getPwaStore().top + "px", width: rstore.getPwaStore().width + "px", height: testIsMobile() ? (window.innerHeight - 150) + "px" : (window.innerHeight - 100) + "px" },
            React.createElement(Flex, { pos: 'relative', "border-bottom": '1px solid lightgray', padding: '10px', align: 'center', "object-viewer": 'colorbox', height: "50px", width: '100%' },
                React.createElement(Text, { overflow: 'hidden', textOverflow: 'ellipsis', title: rstore.getPwaStore().activeDocumentname, width: '60%', "object-viewer": 'colorbox', fontWeight: 'bold', fontSize: '12px', fontFamily: 'heading', color: AppColor.InputLabelColor }, rstore.getPwaStore().activeDocumentname),
                React.createElement(Icon, { pos: 'absolute', right: '5px', ml: '20px', as: MdClose, color: AppColor.ResetFilter, h: '25px', w: '25px', _hover: { cursor: 'pointer' }, onClick: () => {
                        rstore.getPwaStore().setShow(false);
                        rstore.getPwaStore().setViewerActive(false);
                        rstore.getPwaStore().setActiveDocumentId("");
                        rstore.getPwaStore().setActiveDocumentName("");
                        let hash = window.location.hash;
                        hash = hash.split("~~~Doc")[0];
                        window.history.replaceState({}, document.title, hash);
                    }, className: 'message-option-button' })),
            !rstore.getPwaStore().queued && !rstore.getPwaStore().isViewable &&
                !rstore.getPwaStore().isexcel &&
                React.createElement(Box, { className: 'viewer-contianer', w: window.innerWidth < 1100 ? window.innerWidth : window.innerWidth - 100, margin: 'auto', h: window.innerHeight - 150 + 'px' },
                    React.createElement(Flex, { flexDirection: 'column', h: '70%', align: 'center', justify: 'center' },
                        React.createElement(Icon, { h: '3em', w: '30px', as: GrDocumentMissing }),
                        React.createElement(Text, { mt: '15px' }, "Preview isn't available for the selected document"))),
            rstore.getPwaStore().queued && !rstore.getPwaStore().isViewable &&
                !rstore.getPwaStore().isexcel &&
                React.createElement(Box, { className: 'viewer-contianer', w: window.innerWidth < 1100 ? window.innerWidth : window.innerWidth - 100, margin: 'auto', h: window.innerHeight - 150 + 'px' },
                    React.createElement(Flex, { flexDirection: 'column', h: '70%', align: 'center', justify: 'center' },
                        React.createElement(Icon, { h: '3em', w: '30px', as: GrDocumentMissing }),
                        React.createElement(Text, { mt: '15px' }, "Document is in processing queue."))),
            rstore.getPwaStore().isViewable && !rstore.getPwaStore().isexcel && React.createElement(PwaPdfViewer, null));
    }
};
PwaFloatingViewContainer.contextType = StoreContext;
PwaFloatingViewContainer = __decorate([
    observer
], PwaFloatingViewContainer);
export { PwaFloatingViewContainer };
